<template>
  <div>
    <b-form-row>
      <h5 class="col-12 text-primary font-weight-bold pb-2">
        Road Construction Activities
      </h5>
    </b-form-row>
    <template v-if="roadExists && roadDetails && isLUPCTown">
    <!-- this section will be updated with additional conditions (notification.statusId > 2 && notification.activeDate < ??) -->    
      <template v-if="false && roadPWLString">
        <div class="font-weight-bold mb-2">{{pwlStatement}}</div>
        <DetailRow label="Area of alteration* will be"
          :value="`${$options.filters.numberString(roadDetails.alterationArea)} sq.ft.`"
        />
        <small>
          *'Alteration' means dredging, bulldozing, removing or replacing soil, sand, vegetation,
          or draining or dewatering, filling, or any construction and/or repair of any permanent
          structure.
          <a
            href="https://www.maine.gov/dacf/lupc/laws_rules/ch10.html"
            target="_blank"
            rel="noopener noreferrer"
          >
            See 10.27 LAND USE DISTRICTS &amp; STANDARDS
          </a>
        </small>
      </template>
      <DetailRow
        v-if="requirements.roadDiscontinueDateRequired"
        class="mt-2"
        label="Use of all proposed temporary land management roads will be discontinued by"
        :value="roadDetails.discontinueDate | dateString"
      />
      <ul class="summary-list">
        <li v-if="roadDetails.femaFloodZone">
          One or more of the proposed land management roads <strong>WILL</strong> be constructed
          through a National Flood Insurance FEMA flood zone in a community.
        </li>
        <li v-else>
          <strong>NONE</strong> of the proposed land management roads will be constructed through a
          National Flood Insurance FEMA flood zone in a community.
        </li>
      </ul>
    </template>
    <p v-else-if="roadExists && !isLUPCTown">
      You indicated you will be constructing road(s) as part of this Operation.
    </p>
    <p v-else>
      No Road Construction Activity is proposed
    </p>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import DetailRow from '@/components/DetailRow.vue';

export default {
  name: 'RoadDetails',
  components: {
    DetailRow,
  },
  computed: {
    ...mapState('ActivityDetails', {
      roadDetails: state => state.activityDetails.roadDetails,
      requirements: state => state.requirements,
    }),
    ...mapState('Notification', {
      notification: state => state.notification,
    }),
    ...mapGetters('Activity', ['roadExists']),
    ...mapGetters('ActivityDetails', ['roadPWLString']),
    ...mapGetters('Notification', ['isLUPCTown']),
    pwlStatement() {
      return `Road construction will pass through the ${this.roadPWLString} LUPC Wetland Protection
          Subdistrict(s).`;
    },
  },
};
</script>
